import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import logo from '../../assets/cvj.png'; // Assuming CVJ logo; update path if needed
import './SplashScreen.css';

const SplashScreen = () => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(false), 5000); // 5 seconds
    return () => clearTimeout(timer);
  }, []);

  // Container animation with a smooth fade-out
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1, transition: { duration: 0.5 } },
    exit: { opacity: 0, transition: { duration: 1, ease: 'easeOut' } },
  };

  // Logo animation with a futuristic pulse and spin
  const logoVariants = {
    hidden: { opacity: 0, scale: 0.8, rotate: -90 },
    visible: {
      opacity: 1,
      scale: 1,
      rotate: 0,
      transition: {
        duration: 1.5,
        type: 'spring',
        stiffness: 120,
        damping: 15,
      },
    },
    pulse: {
      scale: [1, 1.05, 1],
      transition: { duration: 2, repeat: Infinity, ease: 'easeInOut' },
    },
  };

  // Description animation with letter stagger and glow
  const descriptionVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
        delay: 0.8,
      },
    },
  };

  const letterVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
  };

  // Split description into individual letters for stagger effect
  const descriptionText = "Delivering UK Freight with Precision";

  return (
    <motion.div
      className={`splash-screen ${isVisible ? 'visible' : 'hidden'}`}
      variants={containerVariants}
      initial="hidden"
      animate={isVisible ? 'visible' : 'exit'}
    >
      <video className="splash-video" autoPlay loop muted playsInline>
        <source
          src="https://assets.mixkit.co/videos/preview/mixkit-truck-on-the-highway-151-large.mp4" // Freight truck video
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
      <motion.img
        src={logo}
        alt="CVJ Services Ltd Logo"
        className="logoo"
        variants={logoVariants}
        initial="hidden"
        animate={['visible', 'pulse']} // Combine entrance and pulsing
      />
      <motion.p className="description" variants={descriptionVariants} initial="hidden" animate="visible">
        {descriptionText.split('').map((char, index) => (
          <motion.span key={index} variants={letterVariants}>
            {char}
          </motion.span>
        ))}
      </motion.p>
    </motion.div>
  );
};

export default SplashScreen;